"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payments = exports.credits = void 0;
exports.credits = "/api/credits{?id_member,currency}";
exports.payments = "/api/payments{?id_orders}";
